import React from "react";
import { Segment } from "semantic-ui-react";
import PrestamoCard from "./PrestamoCard";
import PropTypes from "prop-types";

const PrestamoList = ({ creditos }) => {
  return (
    <Segment.Group raised>
      {creditos &&
        creditos.map((credito) => (
          <PrestamoCard key={credito.credito} credito={credito} />
        ))}
    </Segment.Group>
  );
};

PrestamoList.propTypes = {
  creditos: PropTypes.array.isRequired,
};

export default PrestamoList;
